<template>
    <div>
        <template v-if="authenticatedUser" data-unauthenticated>
            <live-channel class="relative" v-if="shouldShowPlayer" />
            <div
                class="pt-20 pb-10 px-2 sm:px-8 bg-contain"
                :style="{
                    backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
                    backgroundColor: '#a000ff'
                }"
                v-else
            >
                <div class="container mx-auto mt-8 mb-5">
                    <no-player-banner />
                </div>
            </div>

            <div
                class="pt-10 pb-10 px-2 sm:px-8 bg-contain"
                :style="{
                    backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
                    backgroundColor: '#fe0084'
                }"
            >
                <characters-slider :series="series" :key="`series_bubbles`" />
            </div>

            <episodes-section
                v-for="(category, index) in categories"
                :key="`category_${index}`"
                :title="category.title"
                :background-image="category.background"
                :background-color="category.background_color"
                :episodes="category.episodes"
            ></episodes-section>

            <games-section :games="games" v-if="!$isMobile()"></games-section>
        </template>

        <template v-else data-unauthenticated>
            <div class="home-anonymous">
                <h1 class="title">{{ $config("HOME_TITLE") }}</h1>
                <p class="text-content-1" v-html="$config('HOME_FIRST')"></p>

                <router-link class="cta" :to="{ name: 'register-sign-up' }">
                    {{ $config("HOME_CTA") }}
                </router-link>

                <p class="text-content-2">{{ $config("HOME_SECOND") }}</p>
                <p class="text-content-3">{{ $config("HOME_THIRD") }}</p>
                <div class="platforms"></div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import NoPlayerBanner from "@/components/NoPlayerBanner.vue";
import LiveChannel from "../components/LiveChannel";
import CharactersSlider from "../components/CharactersSlider";
import EpisodesSection from "../components/EpisodesSection";
import GamesSection from "../components/GamesSection";

export default {
    name: "home",

    components: {
        NoPlayerBanner,
        LiveChannel,
        CharactersSlider,
        EpisodesSection,
        GamesSection
    },

    created() {
        this.$store.dispatch("FETCH_INITIAL_DATA");
    },

    computed: {
        ...mapState([
            "_ga",
            "series",
            "categories",
            "games",
            "homeData",
            "freeContent",
            "authenticatedUser"
        ]),
        ...mapGetters(["getGa"])
    },

    data() {
        return {
            shouldShowPlayer: false
        };
    }
};
</script>

<style scoped lang="scss">
.home-anonymous {
    background: url("~@/assets/img/new/pinguinitos-bg.jpg") center/cover
        no-repeat;
    @supports (
        background-image: url("~@/assets/img/new/pinguinitos-bg.jpg.webp")
    ) {
        background-image: url("~@/assets/img/new/pinguinitos-bg.jpg.webp");
    }

    width: 100%;
    height: 100vh;
    min-height: 890px;
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: center; /* <-- Centers the whole block vertically */
    align-items: center;
    text-align: center;

    padding-top: 120px;
    padding-bottom: 120px;

    /* Remove broken vertical-centering rules */
    > *:first-child,
    > *:last-child {
        margin: 0;
    }

    .title,
    .text-content-1,
    .text-content-2,
    .text-content-3,
    .cta,
    .platforms {
        margin: 0;
        flex-shrink: 0;
    }

    .title {
        font-family: "Encode Sans Semi Expanded", sans-serif;
        font-weight: 700;
        color: #fff;
        width: 870px;
        font-size: 4.375rem;
        line-height: 4.725rem;
        margin-bottom: 72px;
    }

    .text-content-1 {
        font-family: "Encode Sans Semi Expanded", sans-serif;
        font-weight: 500;
        color: #fff;
        font-size: 35px;
        line-height: 43px;
        max-width: 800px;
        margin-bottom: 60px;
    }

    .cta {
        width: 36vw;
        max-height: 64px;
        padding: 1rem 2.0625rem;
        border-radius: 2.375rem;
        background: #28d4ff;
        box-shadow: 0 0.25rem 0.25rem rgba(4, 3, 28, 0.27);
        color: #fff;
        font-family: "Encode Sans Semi Expanded", sans-serif;
        font-size: 26px;
        font-weight: 600;
        letter-spacing: -0.01em;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.625rem;
        margin-bottom: 60px;
    }

    .text-content-2 {
        font-family: "Encode Sans Semi Expanded", sans-serif;
        color: #fff;
        font-size: 36px;
        line-height: 84px;
        letter-spacing: -0.02em;
        font-weight: 700;
        max-width: 800px;
        margin-bottom: 16px;
    }

    .text-content-3 {
        font-family: "Encode Sans Semi Expanded", sans-serif;
        color: #fff;
        font-size: 22px;
        line-height: 84px;
        letter-spacing: -0.02em;
        font-weight: 400;
        max-width: 1100px;
        margin-bottom: 40px;
        margin-top: -32px;
    }

    .platforms {
        background: url("~@/assets/img/new/platforms.png") center/contain
            no-repeat;
        @supports (
            background-image: url("~@/assets/img/new/platforms.png.webp")
        ) {
            background-image: url("~@/assets/img/new/platforms.png.webp");
        }
        width: 943px;
        height: 71px;
    }

    @media (max-width: 960px) {
        padding-top: 120px;
        padding-bottom: 120px;

        .title {
            width: 80vw;
            font-size: 35px;
            line-height: 44px;
            margin-bottom: 48px;
        }

        .text-content-1 {
            font-size: 24px;
            line-height: 32px;
            margin-bottom: 40px;
            max-width: 85vw;
        }

        .cta {
            width: 268px;
            max-height: 49px;
            padding: 1rem 2rem;
            font-size: 20px;
            margin-bottom: 40px;
        }

        .text-content-2 {
            font-size: 28px;
            line-height: 36px;
            margin-bottom: 12px;
            max-width: 85vw;
        }

        .text-content-3 {
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 30px;
            margin-top: -4px;
            max-width: 85vw;
        }

        .platforms {
            width: 375px;
            height: 36px;
        }
    }
}

.home-anonymous::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
    pointer-events: none;
}

.home-anonymous > * {
    position: relative;
    z-index: 2;
}

.head-logged {
    background: url("~@/assets/img/fondo_arboles.jpg") bottom center/cover
        no-repeat;
    height: 280px;
}

.series_bubbles {
    z-index: 5;
    top: 100px;
}

.series_bubbles_logged {
    position: relative;
    z-index: 5;
    padding-top: 110px;
}
</style>
